import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X, Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

const LOGO = "https://customer-assets.emergentagent.com/job_tripsi-launch/artifacts/7y1dc8ot_full_logo_red.png";

export function CinematicNav({ activeScene, onDownload }) {
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const toggleLang = () => { const n = i18n.language === "en" ? "fr" : "en"; i18n.changeLanguage(n); localStorage.setItem("tripsi_lang", n); };

  const scenes = [
    { id: "intro", label: t("nav.home") },
    { id: "riders", label: t("nav.riders") },
    { id: "drivers", label: t("nav.drivers") },
    { id: "businesses", label: t("nav.businesses") },
    { id: "contact", label: t("nav.contact") },
  ];

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav data-testid="cinematic-nav" className="fixed top-0 left-0 right-0 z-[100]">
      <div className="bg-black/40 backdrop-blur-2xl border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-8 flex items-center justify-between h-16">
          <button onClick={() => scrollTo("intro")} data-testid="logo-link" className="flex items-center gap-3 shrink-0">
            <img src={LOGO} alt="Tripsi" className="h-14 md:h-16 w-auto" />
          </button>
          <div className="hidden lg:flex items-center gap-6">
            {scenes.map(s => (
              <button key={s.id} onClick={() => scrollTo(s.id)} data-testid={`nav-${s.id}`} className={`text-sm font-medium transition-all duration-300 ${activeScene === s.id ? "text-[#E60000]" : "text-white/50 hover:text-white"}`}>{s.label}</button>
            ))}
          </div>
          <div className="hidden lg:flex items-center gap-3">
            <button onClick={toggleLang} data-testid="language-toggle" className="flex items-center gap-1.5 text-white/50 hover:text-white text-sm px-2 py-1 border border-white/10 hover:border-white/20 transition-colors">
              <Globe size={13} /><span className="uppercase">{i18n.language === "en" ? "FR" : "EN"}</span>
            </button>
            <a href="tel:+16472499977" className="flex items-center gap-2 bg-[#E60000] hover:bg-[#FF3B30] text-white px-4 py-2 text-sm font-semibold transition-colors"><Phone size={14} />{t("nav.callDispatch")}</a>
          </div>
          <button onClick={() => setOpen(!open)} className="lg:hidden text-white p-2">{open ? <X size={22} /> : <Menu size={22} />}</button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} className="lg:hidden bg-black/90 backdrop-blur-2xl border-b border-white/5 overflow-hidden">
            <div className="px-6 py-4 flex flex-col gap-4">
              {scenes.map(s => (<button key={s.id} onClick={() => scrollTo(s.id)} className={`text-left text-base font-medium ${activeScene === s.id ? "text-[#E60000]" : "text-white/60"}`}>{s.label}</button>))}
              <button onClick={toggleLang} className="text-white/50 text-sm border border-white/10 px-3 py-1 self-start"><Globe size={13} className="inline mr-1" />{i18n.language === "en" ? "FR" : "EN"}</button>
              <a href="tel:+16472499977" className="flex items-center gap-2 bg-[#E60000] text-white px-5 py-3 text-sm font-semibold justify-center"><Phone size={14} />{t("nav.callDispatch")}</a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
